var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQyTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qyTag_svg__clip0_8834_10506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.111.513a1.778 1.778 0 011.778 0l5.15 2.974c.55.317.89.904.89 1.54v5.947c0 .635-.34 1.222-.89 1.54l-5.15 2.973a1.778 1.778 0 01-1.778 0l-5.15-2.974a1.778 1.778 0 01-.89-1.54V5.027c0-.635.34-1.222.89-1.54L7.11.514z",
    fill: "url(#qyTag_svg__paint0_linear_8834_10506)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.158 4.64L8.333 1.853a.667.667 0 00-.667 0L2.841 4.639a.667.667 0 00-.333.578v5.571c0 .238.127.458.333.578l4.825 2.785c.207.12.46.12.667 0l4.825-2.785a.667.667 0 00.333-.578V5.217a.667.667 0 00-.333-.578zM8.666 1.275a1.333 1.333 0 00-1.333 0L2.508 4.062a1.333 1.333 0 00-.667 1.155v5.571c0 .477.254.917.667 1.155l4.825 2.786c.413.238.92.238 1.333 0l4.825-2.786c.413-.238.667-.678.667-1.155V5.217c0-.477-.254-.917-.667-1.155L8.666 1.276z",
    fill: "#386BDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.735 4.258h.53a10.627 10.627 0 003.278 2.44l-.393.695A10.193 10.193 0 018 4.9c-.801.967-1.866 1.798-3.181 2.5l-.385-.694c1.322-.65 2.425-1.466 3.301-2.448zm.121 2.032h.718v1.617h2.002v.688H8.574v1.662h2.546v.695H4.79v-.695h1.088V7.378h.71v2.879h1.27V6.29z",
    fill: "#245BDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qyTag_svg__paint0_linear_8834_10506",
    x1: 4.444,
    y1: 2,
    x2: 11.556,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qyTag_svg__clip0_8834_10506"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/qyTag.0d8d5aa4.svg";
export { SvgQyTag as ReactComponent };